export default __webpack_public_path__ + "static/orangeloop-29-8ad497be36264d969b4a140a0b5eca91.jpg";